import { STAGE_WORKFLOW } from './constants';

function readStageRow(row) {
  const code = Number(row?.stageCode ?? row?.StageCode);
  const orderNo = Number(row?.orderNo ?? row?.OrderNo ?? 0);
  const stageName = String(row?.stageName ?? row?.StageName ?? '').trim().toLowerCase();
  const label = String(row?.label ?? row?.Label ?? '').trim();
  return { code, orderNo, stageName, label, row };
}

/** Ordered review tiers for a project (parity with CRFStageService.QueryOrderedReviewDisplayNamesAsync). */
export function resolveOrderedReviewStages(stageList) {
  const inBand = (Array.isArray(stageList) ? stageList : [])
    .map(readStageRow)
    .filter((s) => !Number.isNaN(s.code)
      && s.code > STAGE_WORKFLOW.IN_PROGRESS
      && s.code < STAGE_WORKFLOW.COMPLETED);

  const named = inBand.filter((s) => s.stageName === 'review');
  const tiers = (named.length > 0 ? named : inBand)
    .sort((a, b) => a.orderNo - b.orderNo || a.code - b.code);

  return tiers;
}

/** First review tier iStageCode for this project's StageMst list (ordered[0]). */
export function resolveFirstReviewStageCode(stageList) {
  const first = resolveOrderedReviewStages(stageList)[0];
  if (!first || Number.isNaN(first.code)) return '';
  return String(first.code);
}

/** First review tier row (code + vDisplayName) for label comparisons. */
export function resolveFirstReviewStageRow(stageList) {
  return resolveOrderedReviewStages(stageList)[0]?.row ?? null;
}

/** True when wantStageCode matches the project's first review tier (code or that row's display name). */
export function isFirstReviewStageGate(wantStageCode, stageList) {
  const ws = String(wantStageCode ?? '').trim();
  if (!ws) return false;

  const firstCode = resolveFirstReviewStageCode(stageList);
  if (!firstCode) return false;

  const wantNum = Number(ws);
  if (!Number.isNaN(wantNum)) return String(wantNum) === firstCode;

  const first = resolveFirstReviewStageRow(stageList);
  if (!first) return false;
  const wl = ws.toLowerCase();
  const lbl = String(first.label ?? first.Label ?? '').trim().toLowerCase();
  const name = String(first.stageName ?? first.StageName ?? '').trim().toLowerCase();
  if (wl === lbl || wl === name) return true;

  const hit = (Array.isArray(stageList) ? stageList : []).find(
    (s) => String(s.stageCode ?? s.StageCode) === ws
  );
  if (hit) return String(hit.stageCode ?? hit.StageCode) === firstCode;
  return false;
}
